import { render } from "./popup.vue?vue&type=template&id=b231d0d2&scoped=true&ts=true"
import script from "./popup.vue?vue&type=script&lang=ts"
export * from "./popup.vue?vue&type=script&lang=ts"

import "./popup.vue?vue&type=style&index=0&id=b231d0d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b231d0d2"]])

export default __exports__